import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

export const getSessionId = () => {
  let id = localStorage.getItem("lea_session");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("lea_session", id);
  }
  return id;
};

export const imageUrl = (id) => `${API}/images/${id}/file`;

export async function streamChat(sessionId, message, onDelta, img) {
  const res = await fetch(`${API}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message, image_base64: img?.base64, image_mime: img?.mime }),
  });
  if (!res.ok) throw new Error("Sem.IA est indisponible pour le moment");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let full = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.delta) {
        full += ev.delta;
        onDelta(full);
      }
    }
  }
  return full;
}

export async function speak(text, voice) {
  const clean = text.replace(/[*#_`>]/g, "").slice(0, 4000);
  const res = await http.post("/tts", { text: clean, voice }, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}

export async function transcribe(blob) {
  const fd = new FormData();
  fd.append("file", blob, "recording.webm");
  const res = await http.post("/stt", fd);
  return res.data.text;
}

export const notify = (title, body) => {
  if (localStorage.getItem("lea_notif") !== "on") return;
  if ("Notification" in window && Notification.permission === "granted") {
    new Notification(title, { body });
  }
};
